<template v-slot:specs-heading>
	<div class="specs-cart-heading row">
		<div class="col-md-2">
			<div class="specs-cart-heading-image">
				<img :src="getPrebuildCoverImage" alt="Case">
			</div>
		</div>
		<div class="col-md-10">
			<h5 class="specs-cart-heading-name text-uppercase">
				<promo-sales-timed>
					<template v-slot:originalContent>
						{{ getPrebuildName }}
					</template>
					<template>
						<div class="holiday-prebuild-name">
							{{ getPrebuildName }}
						</div>
					</template>
				</promo-sales-timed>
			</h5>

			<h5 class="specs-cart-heading-price">
				<promo-sales-timed class="holiday-discount">
					<template v-slot:originalContent>
						<span>{{ getPrebuildPrice | formatMoney(0) }}</span>
					</template>
					<template>
						<span>
							{{ promoDiscount(getPrebuildPrice) | formatMoney }}
							<br>
							<span class="discounted-price">{{ getPrebuildPrice | formatMoney }}</span>
						</span>
					</template>
				</promo-sales-timed>
			</h5>
		</div>
	</div>
</template>

<script>
import PromoSalesTimed from "@/components/promo-sales-timed";
import { promoDiscount } from "@u/helpers";

export default {
	name: "SpecsCartHeading",
	components: {
		PromoSalesTimed
	},
	props: {
		prebuildDetails: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	computed: {
		getPrebuildName() {
			return this.prebuildDetails.name;
		},
		getPrebuildCoverImage() {
			return this.prebuildDetails.cover_image;
		},
		getPrebuildPrice() {
			return this.prebuildDetails.price;
		}
	},
	methods: {
		promoDiscount
	}
};
</script>

<style lang="scss" scoped>
.specs-cart-heading::v-deep {
	.holiday-prebuild-name {
		font-size: 14px;

		@media (min-width: 768px) {
			font-size: 16px;
		}
	}

	.holiday-discount {
		text-align: right;
		font-size: 14px;

		@media (min-width: 768px) {
			font-size: 16px;
			text-align: inherit;

			br {
				display: none;
			}
		}
	}

	.discounted-price {
		color: #141226 !important;
		font-size: 14px !important;
		font-weight: normal !important;
		text-decoration: line-through !important;
	}
}


.specs-cart-heading {
	margin-top: -50px;
	display: flex;
	justify-content: space-between;
	position: relative;
	top: 58px;

	@media (min-width: 320px) and (max-width: 991px) {
		margin-top: 0;
		position: static;
		margin-bottom: 17px;
		justify-content: flex-start;
	}

	&-image {
		margin: 0 22px 0 auto;
		width: 96px;
		height: 96px;

		@media (min-width: 320px) and (max-width: 580px) {
			width: 86px;
			height: 86px;
		}

		img {
			margin-left: auto;
			width: 100%;
		}
	}

	&-name,
	&-price {
		color: #141226;
		font-size: 16px;
		font-weight: bold;
	}

	&-price {
		margin-right: 25px;

		@media (min-width: 320px) and (max-width: 580px) {
			margin-right: 0;
		}
	}

	.col-md-2 {
		@media (min-width: 320px) and (max-width: 580px) {
			width: 30%;
		}
	}

	.col-md-10 {
		position: relative;
		right: 40px;
		display: flex;
		justify-content: space-between;

		@media (min-width: 320px) and (max-width: 580px) {
			position: static;
			width: 70%;
			display: flex;
			justify-content: space-between;
		}

		@media (min-width: 581px) and (max-width: 991px) {
			width: 100%;
		}
	}
}
</style>
